<template>
  <div v-if="expressionBesoin">
    <div class="row">
      <div class="col-lg-6">
        <BreadCrumd
          :title="'Expressions de besoin'"
          :description="'Modification d\'une expression de besoin'"
        />
      </div>
      <div class="col-lg-6 mt-lg-4" v-if="expressionBesoin.document">
        <div class="row">
          <div class="col-md-12">
            <table
              class="card table table-sm table-custom-primary table-bordered mb-0"
            >
              <tbody>
                <tr class="d-flex font-size-17 font-weight-bold">
                  <td class="col-6 text-custom-primary">
                    Référence : {{ expressionBesoin.document.reference }}
                  </td>
                  <td class="col-6">
                    Statut :
                    <i
                      :class="[
                        {
                          'text-warning':
                            expressionBesoin.statut === CONST.EN_ATTENTE,
                          'text-success':
                            expressionBesoin.statut === CONST.VALIDER ||
                            expressionBesoin.statut === CONST.DEMANDE_ACHAT ||
                            expressionBesoin.statut === CONST.COLLECTE_PRIX,
                          'text-danger':
                            expressionBesoin.statut === CONST.REFUSER,
                        },
                        icons.ICON_STATUT,
                        'mr-1',
                      ]"
                    ></i>
                    {{ getStatutEB(expressionBesoin.statut) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <Relationship :steps="steps" :currentStep="currentStep" />
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12 col-lg-6">
        <button
          type="button"
          class="btn btn-secondary mr-4"
          @click.prevent="
            $router.push({ name: 'achat_expression_besoin' }).catch(() => {})
          "
        >
          Liste des expressions de besoin
        </button>
        <button
          type="button"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({ name: 'achat_expression_besoin-create' })
              .catch(() => {})
          "
        >
          <i :class="icons.ICON_ADD"></i>
          Nouvelle expression de besoin
        </button>

        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: 'achat_expression_besoin-show',
                params: { id: expressionBesoin.id },
              })
              .catch(() => {})
          "
        >
          <i :class="icons.ICON_SHOW" class="font-size-17"></i> Aperçu
        </button>
      </div>
      <div
        class="col-md-12 col-lg-6"
        v-if="
          expressionBesoin.statut !== CONST.DEMANDE_ACHAT &&
          expressionBesoin.statut !== CONST.COLLECTE_PRIX
        "
      >
        <b-button
          variant="success"
          class="btn-icon mr-4"
          @click="valider"
          v-if="expressionBesoin.statut === CONST.EN_ATTENTE"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_VALIDATE"></i>
          </span>
          Valider
        </b-button>
        <b-button
          variant="danger"
          class="btn-icon mr-4"
          @click="refuser"
          v-if="expressionBesoin.statut === CONST.EN_ATTENTE"
        >
          <span class="btn-icon-label">
            <i :class="icons.ICON_REFUSE"></i>
          </span>
          Réfuser
        </b-button>

        <button
          v-if="expressionBesoin.statut === CONST.VALIDER"
          type="button"
          title="Transformer en collecte de prix"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({
                name: 'achat_sourcing-create',
                params: { filter: 'eb', id: expressionBesoin.id },
              })
              .catch(() => {})
          "
        >
          <i :class="icons.ICON_COLLECT_PRICE" class="font-size-17"></i>
          Collecte de prix
        </button>

        <button
          v-if="expressionBesoin.statut === CONST.VALIDER"
          type="button"
          title="Transformer en demande d'achat"
          class="btn btn-custom-primary mr-4"
          @click.prevent="
            $router
              .push({
                name: 'achat_demande-create',
                params: { filter: 'eb', id: expressionBesoin.id },
              })
              .catch(() => {})
          "
        >
          <i :class="icons.ICON_DMD_ACHAT" class="font-size-17"></i> Demande
          d'achat
        </button>

        <b-button variant="warning" class="btn-icon" @click="reinitialiser">
          <span class="btn-icon-label">
            <i :class="icons.ICON_RESET"></i>
          </span>
          Réinitialiser
        </b-button>
      </div>
    </div>

    <div class="mt-4 mt-lg-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <b-nav tabs>
            <b-nav-item
              :to="{ name: 'achat_expression_besoin-edit', params: { id: id } }"
              exact
              exact-active-class="active"
              ><i
                :class="icons.ICON_EDIT"
                class="text-custom-primary font-size-17"
              ></i>
              Expression de besoin</b-nav-item
            >
            <b-nav-item
              :to="{
                name: 'achat_expression_besoin_edit-document',
                params: {
                  id: id,
                  documentUuid: expressionBesoin.document.uuid,
                },
              }"
              exact
              exact-active-class="active"
              ><i
                :class="icons.ICON_DOCUMENT"
                class="text-custom-primary font-size-17"
              ></i>
              Documents</b-nav-item
            >
          </b-nav>
        </div>
      </div>

      <div>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/achat/expression-besoin';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import CONST from '@/constants/achat/expression-besoin';
import { editLayout as icons } from '@/icons/achat/expression-besoin';

export default {
  data() {
    return {
      id: null,
      expressionBesoin: null,
      title: 'Gestion des expressions de besoin - Edition',
      CONST,
      icons,
    };
  },
  computed: {
    ...mapGetters('eb', ['currentStep', 'steps']),
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    valider() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.VALIDER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    refuser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REFUSER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    reinitialiser() {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL.REINITIALISER + '/' + this.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    ...mapActions('eb', ['setCurrentStep']),
    init() {
      this.id = this.$route.params.id;

      window.axios
        .get(URL.EXPRESSION_BESOIN + '/' + this.id)
        .then((resp) => {
          this.expressionBesoin = resp.data.expression_besoin;
          this.setCurrentStep(this.expressionBesoin.statut);
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
